module.exports = __webpack_public_path__ + "static/media/leadImport.cb2803ec.xlsx";